import React, { useState, lazy, Suspense, useRef, useMemo, useCallback, } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { BiEventType } from '../../../biLogger';
import { URLS } from '@wix/da-url/dist/src/constants';
import ChatIcon from '../../../Icons/Comment';
import { IconSize } from '../../../Icons/IconWrap';
import VisuallyHidden from '../../../a11y/VisuallyHidden';
import PlainButtonOrLink from '../../../Button/PlainButtonOrLink';
import ErrorBoundary from '../../../ErrorBoundary';
import { useIsMounted } from '../../../utils/hooks/useIsMounted';
import throttle from 'lodash/throttle';
var DesktopChatPanelDropdown = lazy(function () {
    return import(
    /* webpackChunkName: "chatdropdown" */
    '../../../ChatV2/ChatPanel/DesktopChatPanelDropdown');
});
import siteHeaderStyles from '../SiteHeader.scss';
import s from './ChatButtonAndDropdown.scss';
export var ChatButtonAndDropdown = function (_a) {
    var indicator = _a.indicator, disableDropdown = _a.disableDropdown;
    // So the dropdown has an a11y way to open
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var t = useTranslation().t;
    var isMounted = useIsMounted();
    var rootRef = useRef(null);
    var enterTimerRef = useRef();
    var throttledMouseLeave = useMemo(function () {
        return throttle(function () {
            clearTimeout(enterTimerRef.current);
            setIsOpen(false);
        }, 300);
    }, []);
    var onMouseEnter = function () {
        enterTimerRef.current = setTimeout(function () {
            setIsOpen(true);
        }, 100);
    };
    var onTouchEnd = function (e) {
        if (!isOpen) {
            e.preventDefault(); // on touch we noop click
        }
        setIsOpen(!isOpen);
    };
    var onClick = function () {
        window.location.assign(URLS.CHAT_HOME);
    };
    var onClose = useCallback(function () {
        throttledMouseLeave();
    }, [throttledMouseLeave]);
    if (disableDropdown) {
        return (React.createElement(PlainButtonOrLink, { href: URLS.CHAT_HOME, className: classnames(siteHeaderStyles['icon-button']), biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'chat',
            } },
            React.createElement("span", null,
                React.createElement(ChatIcon, { size: IconSize.MEDIUM, disableDefaultColors: true, className: siteHeaderStyles['chat-icon'] }),
                indicator)));
    }
    return (React.createElement("div", { className: classnames(s['root'], siteHeaderStyles['icon-button-has-submenu']), onMouseEnter: onMouseEnter, onMouseLeave: onClose, onTouchEnd: onTouchEnd, ref: rootRef },
        React.createElement(PlainButtonOrLink, { onClick: onClick, className: classnames(siteHeaderStyles['icon-button'], isOpen && siteHeaderStyles['toggled']), "aria-haspopup": "true", "aria-expanded": isOpen, biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'chat',
            } },
            React.createElement("span", null,
                React.createElement(ChatIcon, { size: IconSize.MEDIUM, disableDefaultColors: true, className: siteHeaderStyles['chat-icon'] }),
                indicator,
                React.createElement(VisuallyHidden, null, t('chat.panel.a11y.openChatPopup')))),
        React.createElement(ErrorBoundary, null, isMounted && isOpen && (React.createElement(Suspense, { fallback: null },
            React.createElement(DesktopChatPanelDropdown, { className: classnames(s['dropdown'], isOpen && s['open']) }))))));
};
ChatButtonAndDropdown.displayName = 'ChatButtonAndDropdown';
export default ChatButtonAndDropdown;
//# sourceMappingURL=ChatButtonAndDropdown.js.map